// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@legalshield/adonis-ux-framework/dist/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--n200: #ededed;--n350: #d3d3d3}", "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAEA,MACE,eAAA,CACA,eAAA","sourcesContent":["@import '../node_modules/@legalshield/adonis-ux-framework/dist/index.css';\n\n:root {\n  --n200: #ededed;\n  --n350: #d3d3d3;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
